/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ExternalProfessional/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import ContactInfo from './ContactInfo/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import ProfileImage from './ProfileImage/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChevronRight from 'DesignSystem/Svgs/Tysiav2ChevronRight/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ExternalProfessional({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/ExternalProfessionals/Content/ExternalProfessional"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let externalProfessionalOtherPersonValueData = fromData.useDataFormat({ viewPath,
context: 'external_professional',
path: 'other.person',
format: fromFormat.patientName,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="left-start"
 offsetMainAxis={-32}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="ExternalProfessional.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-1d2USE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-1d2USE': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-3-1d2USE': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfileImage
  viewPath={`${viewPath}/ProfileImage`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral900}
 size="small"
 data="external_professional.other.person"
 format="/Data/format.js patientName"
 text={externalProfessionalOtherPersonValueData}
/>
<div
  data-testid="ExternalProfessional.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2ChevronRight
  viewPath={`${viewPath}/Tysiav2ChevronRight`}
/>
</div>
</div>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<ContactInfo
{...childProps}
  viewPath={`${viewPath}/ContactInfo`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}